import { createClassName } from 'utils/createClassName';

import './dashboardPageStyles.scss';

export const createDashboardPageClassName = createClassName('dashboard-page');
